<template>
  <div class="body-wrapper">
    <div>
      <nav-bar />
      <b-container fluid>
        <div class="main-panel row">
          <div class="col-md-12 col-lg-9 col-xl-9">
            <div class="dashboard-wrapper">
              <!-- first row -->
<!--              <b-row>-->
<!--                <b-col>-->
<!--                  <h1 class="font-weight-bold mb-4">-->
<!--                    {{ dashboardData.greeting }}-->
<!--                    {{ $store.state.authenticatedUserData.user.full_name }},-->
<!--                  </h1>-->
<!--                </b-col>-->
<!--              </b-row>-->

              <h3 class="mb-3">
                {{ dashboardData.business_details.company_name }}
              </h3>

              <b-row>
                <b-col lg="4" md="6" sm="6" class="grid-margin stretch-card">
                  <b-card>
                    <div class="">
                      <h3 class="mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">
                        0
                      </h3>
                    </div>
                    <p class="mb-0 mt-2">Active Work Orders</p>
                  </b-card>
                </b-col>

                <b-col lg="4" md="6" sm="6" class="grid-margin stretch-card">
                  <b-card>
                    <div class="">
                      <h3 class="mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">
                        0
                      </h3>
                    </div>
                    <p class="mb-0 mt-2">Work Orders Due Soon</p>
                  </b-card>
                </b-col>

                <b-col lg="4" md="6" sm="6" class="grid-margin stretch-card">
                  <b-card>
                    <div class="">
                      <h3 class="mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">
                        0
                      </h3>
                    </div>
                    <p class="mb-0 mt-2">Expression of Interests</p>
                  </b-card>
                </b-col>
              </b-row>

              <h4 class="my-4">Quotes Management</h4>
              <b-row class="db-box">
                <b-col xl="4" lg="6" md="6" sm="12" class="card-margin">
                  <b-card header-tag="header" class="quotes-info">
                    <template #header>
                      <h4 class="card-title">
                        <span class="db-count">
                          {{ dashboardData.counts.open_quotes }}</span
                        >
                        Open
                      </h4>
                      <router-link
                        class="db-view-btn"
                        :to="{
                          name: 'manager-quotes',
                          query: { filterStatus: 'open' },
                        }"
                        >View All</router-link
                      >
                    </template>

                    <b-list-group>
                      <b-list-group-item
                        v-for="(
                          quote, index
                        ) in dashboardData.quotes.open_quotes.slice(0, 5)"
                        :key="index"
                        :to="{
                          name: 'manager-quote-view',
                          params: { id: quote.id },
                          query: {
                            manager_id: filterManager,
                          },
                        }"
                      >
                        <div class="db-content">
                          {{ quote.organization_id }}

                          <div class="db-content-details">
                            <!-- <span class="db-num">3</span> -->
                            <span class="db-arrow pl-2"
                              ><i
                                class="fa fa-chevron-right"
                                aria-hidden="true"
                              ></i
                            ></span>
                          </div>
                        </div>
                      </b-list-group-item>

                      <b-list-group-item
                        v-if="dashboardData.quotes.open_quotes.length < 1"
                        >No Quotes Available</b-list-group-item
                      >
                    </b-list-group>
                    <!-- <b-button
                                        v-if="dashboardData.quotes.open_quotes.length > 0"
                                            variant="outline-primary"
                                            :to="{
                                                name: 'manager-quotes',
                                                query: { filterStatus: 'open' }
                                            }"
                                            >View All</b-button
                                        > -->
                  </b-card>
                </b-col>

                <b-col xl="4" lg="6" md="6" sm="12" class="card-margin">
                  <b-card header-tag="header">
                    <template #header>
                      <h4 class="card-title">
                        <span class="db-count">{{
                          dashboardData.counts.active_quotes
                        }}</span>
                        Active
                      </h4>
                      <router-link
                        class="db-view-btn"
                        :to="{
                          name: 'manager-quotes',
                          query: {
                            filterStatus: 'active',
                          },
                        }"
                        >View All</router-link
                      >
                    </template>
                    <b-list-group>
                      <b-list-group-item
                        v-for="(
                          quote, index
                        ) in dashboardData.quotes.active_quotes.slice(0, 5)"
                        :key="index"
                        :to="{
                          name: 'manager-quote-view',
                          params: { id: quote.id },
                          query: {
                            manager_id: filterManager,
                          },
                        }"
                      >
                        <div class="db-content">
                          {{ quote.organization_id }}

                          <div class="db-content-details">
                            <!-- <span class="db-num">3</span> -->
                            <span class="db-arrow pl-2"
                              ><i
                                class="fa fa-chevron-right"
                                aria-hidden="true"
                              ></i
                            ></span>
                          </div>
                        </div>
                      </b-list-group-item>
                      <b-list-group-item
                        v-if="dashboardData.quotes.active_quotes.length < 1"
                        >No Quotes Available</b-list-group-item
                      >
                    </b-list-group>
                  </b-card>
                </b-col>

                <b-col xl="4" lg="6" md="6" sm="12" class="card-margin">
                  <b-card header-tag="header">
                    <template #header>
                      <h4 class="card-title">
                        <span class="db-count">{{
                          dashboardData.counts.pending_approval_quotes
                        }}</span>
                        Pending Approval
                      </h4>
                      <router-link
                        class="db-view-btn"
                        :to="{
                          name: 'manager-quotes',
                          query: {
                            filterStatus: 'pending-approval',
                          },
                        }"
                        >View All</router-link
                      >
                    </template>
                    <b-list-group>
                      <b-list-group-item
                        v-for="(
                          quote, index
                        ) in dashboardData.quotes.pending_approval_quotes.slice(
                          0,
                          5
                        )"
                        :key="index"
                        :to="{
                          name: 'manager-quote-view',
                          params: { id: quote.id },
                          query: {
                            manager_id: filterManager,
                          },
                        }"
                      >
                        <div class="db-content">
                          {{ quote.organization_id }}

                          <div class="db-content-details">
                            <!-- <span class="db-num">3</span> -->
                            <span class="db-arrow pl-2"
                              ><i
                                class="fa fa-chevron-right"
                                aria-hidden="true"
                              ></i
                            ></span>
                          </div>
                        </div>
                      </b-list-group-item>
                      <b-list-group-item
                        v-if="
                          dashboardData.quotes.pending_approval_quotes.length <
                          1
                        "
                        >No Quotes Available</b-list-group-item
                      >
                    </b-list-group>
                  </b-card>
                </b-col>

                <b-col xl="4" lg="6" md="6" sm="12" class="card-margin">
                  <b-card header-tag="header">
                    <template #header>
                      <h4 class="card-title">
                        <span class="db-count">{{ dashboardData.counts.due_quotes }}</span>
                        Due Soon
                      </h4>
                      <router-link
                        class="db-view-btn"
                        :to="{
                          name: 'manager-quotes',
                          query: {
                            filterStatus: 'due-soon',
                          },
                        }"
                        >View All</router-link
                      >
                    </template>
                    <b-list-group>
                      <b-list-group-item
                        v-for="(
                          quote, index
                        ) in dashboardData.quotes.due_quotes.slice(0, 5)"
                        :key="index"
                        :to="{
                          name: 'manager-quote-view',
                          params: { id: quote.id },
                          query: {
                            manager_id: filterManager,
                          },
                        }"
                      >
                        <div class="db-content">
                          {{ quote.organization_id }}

                          <div class="db-content-details">
                            <!-- <span class="db-num">3</span> -->
                            <span class="db-arrow pl-2"
                              ><i
                                class="fa fa-chevron-right"
                                aria-hidden="true"
                              ></i
                            ></span>
                          </div>
                        </div>
                      </b-list-group-item>
                      <b-list-group-item
                        v-if="dashboardData.quotes.due_quotes.length < 1"
                        >No Quotes Available</b-list-group-item
                      >
                    </b-list-group>
                  </b-card>
                </b-col>

                <b-col xl="4" lg="6" md="6" sm="12" class="card-margin">
                  <b-card header-tag="header">
                    <template #header>
                      <h4 class="card-title">
                        <span class="db-count">{{
                          dashboardData.counts.overdue_quotes
                        }}</span>
                        Over Due
                      </h4>
                      <router-link
                        class="db-view-btn"
                        :to="{
                          name: 'manager-quotes',
                          query: {
                            filterStatus: 'overdue',
                          },
                        }"
                        >View All</router-link
                      >
                    </template>

                    <b-list-group>
                      <b-list-group-item
                        v-for="(
                          quote, index
                        ) in dashboardData.quotes.overdue_quotes.slice(0, 5)"
                        :key="index"
                        :to="{
                          name: 'manager-quote-view',
                          params: { id: quote.id },
                          query: {
                            manager_id: filterManager,
                          },
                        }"
                      >
                        <div class="db-content">
                          {{ quote.organization_id }}

                          <div class="db-content-details">
                            <!-- <span class="db-num">3</span> -->
                            <span class="db-arrow pl-2"
                              ><i
                                class="fa fa-chevron-right"
                                aria-hidden="true"
                              ></i
                            ></span>
                          </div>
                        </div>
                      </b-list-group-item>
                      <b-list-group-item
                        v-if="dashboardData.quotes.overdue_quotes.length < 1"
                        >No Quotes Available</b-list-group-item
                      >
                    </b-list-group>
                  </b-card>
                </b-col>
              </b-row>

              <!-- footer row -->
              <b-row>
                <b-col md="12" class="d-none d-lg-block mt-2">
                  <footer-component></footer-component>
                </b-col>
              </b-row>
            </div>
          </div>

          <div class="col-md-12 col-lg-3 col-xl-3 notification-bar">
            <b-col md="12" class="h">
              <div class="mb-4">
                <h4 class="my-4">Notifications</h4>
                <ul
                  class="recent-act"
                  v-if="dashboardData.notifications && dashboardData.notifications.length > 0"
                >
                  <li
                    class="activity"
                    v-for="(notification, idx) in dashboardData.notifications"
                    :key="'noti' + idx"
                  >
                    <span
                      class="color"
                      v-if="notification.read_at"
                      style="background: #c9c9c9"
                    ></span>
                    <span class="color" v-else></span>

                    <div class="notification">
                      <p class="info">
                        <router-link
                          :style="
                            notification.read_at
                              ? 'text-decoration:none;color: #3a3b45'
                              : 'text-decoration:none'
                          "
                          exact
                          v-on:click.native="
                            markNotificationAsRead(notification)
                          "
                          :to="{
                            name: setRouteName(notification.data.type),
                            params: {
                              id: notification.data.action_id,
                            },
                          }"
                        >
                          {{ notification.data.text }}
                        </router-link>
                        <!-- <span class="quote"><a href="#!">IN-BEN002.</a></span> -->
                      </p>
                      <p class="time">
                        {{ momentDateFromNow(notification.created_at) }}
                      </p>
                    </div>
                  </li>
                </ul>
                <p v-else>no notifications found.</p>
                <b-button
                  v-if="dashboardData.notifications && dashboardData.notifications.length > 0"
                  variant="outline-primary"
                  class="mt-4 mx-auto"
                  :to="{ name: 'manager-notifications' }"
                  style="display: block; width: 50%"
                  >View All</b-button
                >
              </div>
            </b-col>
          </div>
        </div>
        <b-row>
          <b-col md="12" class="d-block d-lg-none mt-2">
            <footer-component></footer-component>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import NavBar from "./includes/NavBar.vue";
import FooterComponent from "../includes/FooterComponent.vue";
import SvgIcons from "@frontendPages/includes/SvgIconsComponent.vue";
import FirebasePushNotificationMixin from "@mixins/firebasePushNotificationMixin.js";
import NotificationRouteMixin from "@mixins/notificationRouteMixin.js";
import axios from "axios";
import moment from "moment";

export default {
  components: {
    NavBar,
    FooterComponent,
    SvgIcons,
  },
  mixins: [FirebasePushNotificationMixin, NotificationRouteMixin],
  data() {
    return {
      filterManager: this.$store.state.authenticatedUserData.user.id,
      dashboardData: {
        business_details: {},
        counts: {},
        notification: [],
        quotes: {
          active_quotes: [],
          due_quotes: [],
          open_quotes: [],
          overdue_quotes: [],
          pending_approval_quotes: [],
        },
      },
    };
  },
  mounted() {
    this.refreshDashboard();
    this.initializeFirebasePushNotificationService();
  },
  methods: {
    refreshDashboard() {
      axios.post("api/manager/dashboard").then((response) => {
        this.dashboardData = response.data;
      });
    },
    markNotificationAsRead(notification) {
      if (notification.read_at) return;
      axios
        .post("api/manager/markNotificationAsRead", {
          uuid: notification.id,
        })
        .then((response) => {});
    },
    momentDateFromNow(date) {
      return moment(date).fromNow();
    },
  },
};
</script>

<style scoped>
.body-wrapper {
  background-color: #f7f7fc;
  position: relative;
}
h1 {
  font-size: 24px;
  color: #000;
}
h4 {
  font-size: clamp(0.9rem, 1vw, 1rem);
  color: #000;
  font-weight: 600;
}
h5 {
  font-size: 18px;
  font-weight: 600;
}
.btn {
  padding: 0.75em 1.2em;
}
</style>
